angular.module('backstage.controllers.tools', [])
    .controller('BtDeeplinkTokenCustomKindController', require('./BtDeeplinkTokenCustomKindController'))
    .controller('BtMetadataSelectorCustomKindController', require('./BtMetadataSelectorCustomKindController'))
    .controller('BtSystemLoaderController', require('./BtSystemLoaderController'));
